import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import categories from '@/mocks/categories';

export default function ArticleNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  const closeMobile = () => setMobileOpen(false);

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
        <div className="w-full px-4 md:px-8">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 text-foreground-900 hover:text-primary-600 transition-colors relative z-[60]"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                K
              </span>
              <span className="font-heading text-lg font-semibold whitespace-nowrap">Kakobuy Finds</span>
            </Link>

            <div className="hidden md:flex items-center gap-4">
              <Link
                to="/"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                ← Powrót
              </Link>
              <Link
                to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik-2026"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                Przewodnik
              </Link>
              <Link
                to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                Poradnik
              </Link>
              <Link
                to="/artykul/kakobuy-spreadsheet-porownanie-arkuszy-2026"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                Porównanie
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Kakobuy Sheet
              </a>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer relative z-[60]"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label={mobileOpen ? 'Zamknij menu' : 'Otwórz menu'}
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden fixed top-16 left-0 right-0 bottom-0 bg-background-50 z-[55] overflow-y-auto shadow-2xl">
          <div className="flex flex-col px-4 py-6">
            <div className="flex flex-col gap-1 mb-6">
              <Link
                to="/"
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                onClick={closeMobile}
              >
                <span className="w-7 h-7 flex items-center justify-center"><i className="ri-home-line"></i></span>
                Strona Główna
              </Link>
              <Link
                to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik-2026"
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                onClick={closeMobile}
              >
                <span className="w-7 h-7 flex items-center justify-center"><i className="ri-book-open-line"></i></span>
                Przewodnik Kakobuy
              </Link>
              <Link
                to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                onClick={closeMobile}
              >
                <span className="w-7 h-7 flex items-center justify-center"><i className="ri-guide-line"></i></span>
                Poradnik
              </Link>
              <Link
                to="/artykul/kakobuy-spreadsheet-porownanie-arkuszy-2026"
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                onClick={closeMobile}
              >
                <span className="w-7 h-7 flex items-center justify-center"><i className="ri-scales-3-line"></i></span>
                Porównanie arkuszy
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
              >
                <span className="w-7 h-7 flex items-center justify-center"><i className="ri-external-link-line"></i></span>
                Kakobuy Sheet
              </a>
            </div>

            <div className="border-t border-background-200 pt-6">
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3 px-3">
                Kategorie produktów
              </h4>
              <div className="grid grid-cols-2 gap-1">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 px-3 py-2 text-xs text-foreground-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                  >
                    <span className="w-5 h-5 flex items-center justify-center text-primary-500 flex-shrink-0">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    <span className="whitespace-nowrap">{cat.name}</span>
                  </a>
                ))}
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-background-200">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex w-full items-center justify-center gap-2 px-5 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                Kakobuy Sheet
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}